var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sb-button',{attrs:{"size":"small","variation":"tertiary"},on:{"click":function($event){_vm.download()}}},[_c('i',{staticClass:"fas far fa-cloud-download-alt"}),_vm._v(" Download")])}
var staticRenderFns = []

export { render, staticRenderFns }